<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { settingsMethods, settingsComputed } from "@/state/helpers";
import Swal from "sweetalert2";

export default {
  components: { Layout, PageHeader },
  data() {
    return {
      title: "App Options",
      fields: [
        {
          label: "Admin Emails",
          value: "",
          name: "admin_emails",
          type: "text",
          required: true,
        },
        {
          label: "Email Subject (Customer / Order Created)",
          value: "",
          name: "email_order_created_subject",
          type: "text",
          required: true,
        },
        {
          label: "Email Title (Customer / Order Created)",
          value: "",
          name: "email_order_created_title",
          type: "text",
          required: true,
        },
        {
          label: "Email Content (Customer / Order Created)",
          value: "",
          name: "email_order_created_content",
          type: "textarea",
          required: true,
        },
        {
          label: "Email Subject (Customer / Order Updated)",
          value: "",
          name: "email_order_update_subject",
          type: "text",
          required: true,
        },
        {
          label: "Email Title (Customer / Order Updated)",
          value: "",
          name: "email_order_update_title",
          type: "text",
          required: true,
        },
        {
          label: "Email Content (Customer / Order Updated)",
          value: "",
          name: "email_order_update_content",
          type: "textarea",
          required: true,
        },
        {
          label: "Email Subject (Customer / Order Under Review)",
          value: "",
          name: "email_order_inreview_subject",
          type: "text",
          required: true,
        },
        {
          label: "Email Title (Customer / Order Under Review)",
          value: "",
          name: "email_order_inreview_title",
          type: "text",
          required: true,
        },
        {
          label: "Email Content (Customer / Order Under Review)",
          value: "",
          name: "email_order_inreview_content",
          type: "textarea",
          required: true,
        },
        {
          label: "Email Subject (Customer / Design Approved)",
          value: "",
          name: "email_order_approved_subject",
          type: "text",
          required: true,
        },
        {
          label: "Email Title (Customer / Design Approved)",
          value: "",
          name: "email_order_approved_title",
          type: "text",
          required: true,
        },
        {
          label: "Email Content (Customer / Design Approved)",
          value: "",
          name: "email_order_approved_content",
          type: "textarea",
          required: true,
        },
        {
          label: "Email Subject (Customer / Design Rejected)",
          value: "",
          name: "email_order_rejected_subject",
          type: "text",
          required: true,
        },
        {
          label: "Email Title (Customer / Design Rejected)",
          value: "",
          name: "email_order_rejected_title",
          type: "text",
          required: true,
        },
        {
          label: "Email Content (Customer / Design Rejected)",
          value: "",
          name: "email_order_rejected_content",
          type: "textarea",
          required: true,
        },
        {
          label: "Email Subject (Customer / Design Completed)",
          value: "",
          name: "email_order_completed_subject",
          type: "text",
          required: true,
        },
        {
          label: "Email Title (Customer / Design Completed)",
          value: "",
          name: "email_order_completed_title",
          type: "text",
          required: true,
        },
        {
          label: "Email Content (Customer / Design Completed)",
          value: "",
          name: "email_order_completed_content",
          type: "textarea",
          required: true,
        },
        {
          label: "Email Subject (Customer / Design Reminder)",
          value: "",
          name: "email_order_reminder_subject",
          type: "text",
          required: true,
        },
        {
          label: "Email Title (Customer / Design Reminder)",
          value: "",
          name: "email_order_reminder_title",
          type: "text",
          required: true,
        },
        {
          label: "Email Content (Customer / Design Reminder)",
          value: "",
          name: "email_order_reminder_content",
          type: "textarea",
          required: true,
        },
      ],
    };
  },
  computed: {
    ...settingsComputed,
  },
  methods: {
    ...settingsMethods,
    saveSettingOptions(e) {
      let thisInstance = this;
      e.preventDefault();
      thisInstance.saveSettings(thisInstance.fields).then(
        function () {
          Swal.fire("Settings Saved!", "", "success");
          thisInstance.loadSavedSettings();
        },
        function (error) {
          Swal.fire({
            icon: "error",
            title: "An error occured",
            text: JSON.stringify(error),
          });
        }
      );
    },
    loadSavedSettings() {
      let thisInstance = this;
      thisInstance.loadSettings().then(
        function () {
          if (thisInstance.settings) {
            thisInstance.settings.forEach(function (settingItem) {
              thisInstance.fields.forEach(function (field) {
                if (field.name == settingItem.name) {
                  field.value = settingItem.val;
                }
              });
            });
          }
        },
        function (error) {
          Swal.fire({
            icon: "error",
            title: "An error occured",
            text: JSON.stringify(error),
          });
        }
      );
    },
  },
  mounted() {
    this.loadSavedSettings();
  },
};
</script>
    
<template>
  <Layout>
    <PageHeader :title="title" />
    <b-form @submit="saveSettingOptions" enctype="multipart/form-data">
      <div class="card">
        <div class="card-body">
          <div
            class="form-group row mb-3"
            v-for="(field, index) in fields"
            :key="index"
          >
            <label class="col-sm-3 col-form-label">
              <span>{{ field.label }}</span>
            </label>
            <div class="col-sm-9">
              <div v-if="field.type == 'text'">
                <input
                  type="text"
                  class="form-control"
                  :name="field.name"
                  :required="field.required"
                  v-model="field.value"
                />
              </div>
              <div v-else-if="field.type == 'textarea'">
                <textarea class="form-control" :name="field.name" rows="10" :required="field.required" v-model="field.value"></textarea>
              </div>
              <div v-else>Invalid Field Type</div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <b-button type="submit">Save Options</b-button>
        </div>
      </div>
    </b-form>
  </Layout>
</template>